import initialState from './initialState'
import {
  LOADING_TRUE,
  LOADING_FALSE,
  LOGIN_USER,
} from './constants'

const AppReducer = (state = initialState, { type, payload }) => {
    switch (type) {
    case LOADING_TRUE:
      return { ...state, loading: true };
    case LOADING_FALSE:
      return { ...state, loading: false };
    case LOGIN_USER:
      return { ...state, info: payload };
    default:
        return state;
    }
}

export default AppReducer;
